import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit"];

  connect() {
    if (this.hasSubmitTarget) setTimeout(() => this.submitTarget.click(), 100);
  }
}
